import React, { useEffect, useState } from 'react';

import { Button } from '@strava/ui/Button';
import { Modal } from '@strava/ui/Modal';
import { getSanitizedUrl } from '@strava/utils/urls';

import { useMRE } from '../../hooks/useMRE';

interface PaywallModalProps {
  showPaywallModal: boolean;
  setShowPaywallModal: (showPaywallModal: boolean) => void;
}

export const PaywallModal = ({
  showPaywallModal,
  setShowPaywallModal
}: PaywallModalProps) => {
  const [redirectUrl, setRedirectUrl] = useState<string | null>(null);

  // Only show the paywall modal if showPaywallModal is true and redirectUrl is set
  const willShowPaywallModal = showPaywallModal && redirectUrl;

  const { t, track } = useMRE();

  useEffect(() => {
    setRedirectUrl(getSanitizedUrl(window.location));
  }, []);

  useEffect(() => {
    // Track paywall modal view only when it is shown, i.e. willShowPaywallModal
    if (willShowPaywallModal) {
      track({
        action: 'screen_enter',
        element: 'paywall_modal'
      });
    }
  }, [willShowPaywallModal, track]);

  const handlePrimaryButtonClick = () => {
    // Track subscribe button click
    track({
      action: 'click',
      element: 'paywall_modal_subscribe_button'
    });

    // Redirect to subscription page
    if (redirectUrl) {
      window.location.href = `/subscribe?redirect=${encodeURIComponent(redirectUrl)}`;
    }
  };

  if (!willShowPaywallModal) {
    return null;
  }

  return (
    <Modal
      open={showPaywallModal}
      onOpenChange={() => setShowPaywallModal(false)} // Close paywall modal
      shouldRenderTriggerButton={false}
      shouldShowCloseButtonIcon={true}
    >
      <Modal.Content>
        <Modal.Title>{t('mre.paywall.subscribe_see_more')}</Modal.Title>
        <Modal.Body>{t('mre.paywall.experience_flyover_logged_in')}</Modal.Body>
        <Modal.Actions>
          <Button onClick={handlePrimaryButtonClick} variant="primary">
            {t('mre.paywall.subscribe')}
          </Button>
        </Modal.Actions>
      </Modal.Content>
    </Modal>
  );
};
